import React, { useRef } from "react";
import "./App.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import { chosenTheme } from "./theme";
import { GlobalStyles } from "./global";

function App() {
  const shellRef = useRef(null);

  const handleShellMove = (event) => {
    const shell = shellRef.current;
    if (!shell) {
      return;
    }
    shell.style.setProperty("--cursor-x", `${event.clientX}px`);
    shell.style.setProperty("--cursor-y", `${event.clientY}px`);
  };

  return (
    <ThemeProvider theme={chosenTheme}>
      <>
        <GlobalStyles />
        <div className="site-shell" ref={shellRef} onMouseMove={handleShellMove}>
          <Main theme={chosenTheme} />
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
